import selectComponent from 'utilities/select-component'
import 'vendor/slick'

export default class SlideShow {
    settings = {
        arrows: true,
        // autoplay: true,
        centerMode: true,
        autoplaySpeed: 3000,
        centerPadding: 0,
        dots: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    adaptiveHeight: false,
                    dots: true,
                }
            }
        ]
    }

    constructor(element) {
        this.$component = selectComponent(element)
        this.$slideShow = this.$component.elements.slides

        this.createSlider()
    }

    createSlider() {
        this.$slideShow.slick(this.settings)
    }
}